// extracted by mini-css-extract-plugin
export var button = "_6d-4";
export var hasDarkBackground = "_6d-7";
export var hasLightBackground = "_6d-6";
export var iconWrapper = "_6d-0";
export var large = "_6d-2";
export var medium = "_6d-1";
export var small = "_6d-5";
export var xsmall = "_6d-3";